import './installCompositionApi.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import localization from '@/plugins/localization'
import vuetify from './plugins/vuetify';
import sidebar from "@/plugins/sidebar";

Vue.config.productionTip = false
Vue.use(localization)
Vue.use(sidebar)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
